import { Stack } from "@mui/material";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import { ScmConfigsEmpty } from "./ScmConfigsEmpty";
import {
  DatagridConfigurable,
  List,
  NumberField,
  TextField,
  BooleanField,
  Button,
  useListContext,
  useCreate,
  useNotify,
  TopToolbar,
  FilterButton,
  ChipField,
  ReferenceArrayField,
  ArrayField,
  SingleFieldList,
  useRefresh,
  EditButton,
} from "react-admin";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import ExposureIcon from "@mui/icons-material/Exposure";
import CustomPagination from "../Componentes/CustomPagination";
import QuickFilter from "../Componentes/BooleanChipFilter";

const filters = [<QuickFilter source="todas" label="Todas" defaultValue />];

const ScmConfigsActions = () => {
  return (
    <TopToolbar>
      <FilterButton disableSaveQuery />
    </TopToolbar>
  );
};

const ZerarProjecoes = () => {
  const { selectedIds, filterValues } = useListContext();
  const [create] = useCreate();
  const notify = useNotify();
  const refresh = useRefresh();

  const BtnZeraExpoLote = (selectedIds: any) => {
    if (!selectedIds.length) {
      notify("Nenhum item selecionado.", { type: "warning" });
      return;
    }

    const payload = {
      zerar_global: {
        zerar_empresas: selectedIds,
        expo: true,
      },
    };

    create(
      "scmconfigs", // Nome do recurso no backend
      { data: payload },
      {
        onSuccess: (response: any) => {
          // console.log("response", response);
          notify(response.mens, { type: "success" });
          setTimeout(() => {
            refresh();
          }, 5000);
        },

        onError: (response: any) => {
          // console.log("Error - response", response);
          notify(`Error: ${response}`, { type: "error" });
        },
      },
    );

    localStorage.setItem("ids", JSON.stringify(selectedIds));
    localStorage.setItem("filters", JSON.stringify(filterValues));
  };

  const BtnZeraSazoLote = (selectedIds: any) => {
    if (!selectedIds.length) {
      notify("Nenhum item selecionado.", { type: "warning" });
      return;
    }

    const payload = {
      zerar_global: {
        zerar_empresas: selectedIds,
        sazo: true,
      },
    };

    create(
      "scmconfigs", // Nome do recurso no backend
      { data: payload },
      {
        onSuccess: (response: any) => {
          // console.log("response", response);
          notify(response.mens, { type: "success" });
          setTimeout(() => {
            refresh();
          }, 5000);
        },

        onError: (response: any) => {
          // console.log("Error - response", response);
          notify(`Error: ${response}`, { type: "error" });
        },
      },
    );

    localStorage.setItem("ids", JSON.stringify(selectedIds));
    localStorage.setItem("filters", JSON.stringify(filterValues));
  };

  const BtnZeraCampLote = (selectedIds: any) => {
    if (!selectedIds.length) {
      notify("Nenhum item selecionado.", { type: "warning" });
      return;
    }
    const payload = {
      zerar_global: {
        zerar_empresas: selectedIds,
        camp: true,
      },

      filtros_analise: filterValues,
    };

    create(
      "scmconfigs", // Nome do recurso no backend
      { data: payload },
      {
        onSuccess: (response: any) => {
          notify(response.mens, { type: "success" });
          setTimeout(() => {
            refresh();
          }, 5000);
        },
        onError: () => {
          notify("Ocorreu algum erro. Por favor tente novamente");
        },
      },
    );

    localStorage.setItem("ids", JSON.stringify(selectedIds));
    localStorage.setItem("filters", JSON.stringify(filterValues));
  };

  const BtnZeraCmmfLote = (selectedIds: any) => {
    if (!selectedIds.length) {
      notify("Nenhum item selecionado.", { type: "warning" });
      return;
    }

    const payload = {
      zerar_global: {
        zerar_empresas: selectedIds,
        cmmf: true,
      },
    };

    create(
      "scmconfigs", // Nome do recurso no backend
      { data: payload },
      {
        onSuccess: (response: any) => {
          notify(response.mens, { type: "success" });
          setTimeout(() => {
            refresh();
          }, 5000);
        },
        onError: () => {
          notify("Ocorreu algum erro. Por favor tente novamente");
        },
      },
    );

    localStorage.setItem("ids", JSON.stringify(selectedIds));
    localStorage.setItem("filters", JSON.stringify(filterValues));
  };

  return (
    <>
      <Button
        size="small"
        color="primary"
        onClick={() => BtnZeraExpoLote(selectedIds)}
        label="Zerar Expo"
      >
        <ExposureIcon />
      </Button>
      <Button
        size="small"
        color="primary"
        onClick={() => BtnZeraSazoLote(selectedIds)}
        label="Zerar Sazo"
      >
        <AnalyticsIcon />
      </Button>
      <Button
        size="small"
        color="primary"
        onClick={() => BtnZeraCampLote(selectedIds)}
        label="Zerar Camp"
      >
        <FactCheckIcon />
      </Button>
      <Button
        size="small"
        color="primary"
        onClick={() => BtnZeraCmmfLote(selectedIds)}
        label="Zerar Cmmf"
      >
        <AnalyticsIcon />
      </Button>
    </>
  );
};

export function ScmConfigsList(props: any) {
  return (
    <List
      filters={filters}
      actions={<ScmConfigsActions />}
      sort={{ field: "id", order: "ASC" }}
      perPage={50}
      // pagination={<ScmConfigsPagination />}
      empty={false}
    >
      <DatagridConfigurable
        rowClick={false}
        bulkActionButtons={<ZerarProjecoes />}
        empty={<ScmConfigsEmpty />}
      >
        <TextField source="id" label="ID" />
        <TextField source="nome_reduzido" label="Empresa" />
        <BooleanField source="proj" label="Proj." />
        <BooleanField source="suprim" label="Suprim" />
        <BooleanField source="compra" label="Compra" />
        <BooleanField source="acesso_restrito" label="Acesso Restrito" />
        <ReferenceArrayField
          reference="producttags"
          source="tags_nd"
          label="Não Distribuir"
        >
          <SingleFieldList>
            <ChipField source="nome_tag" size="small" />
          </SingleFieldList>
        </ReferenceArrayField>
        <NumberField
          source="quant_expo"
          label="Quant Expo"
          options={{ useGrouping: false }}
        />
        <NumberField
          source="quant_sazo"
          label="Quant Sazo"
          options={{ useGrouping: false }}
        />
        <NumberField
          source="quant_camp"
          label="Quant Campo"
          options={{ useGrouping: false }}
        />
        <NumberField
          source="quant_cmmf"
          label="Quant CMMF"
          options={{ useGrouping: false }}
        />
        <ArrayField source="calendario" label="Calendário" sortable={false}>
          <SingleFieldList>
            <ChipField source="dia" size="small" />
          </SingleFieldList>
        </ArrayField>
        <EditButton label="" />
      </DatagridConfigurable>
    </List>
  );
}
